import * as React from "react";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { UseFormRegister, FormState } from "react-hook-form/dist/types";

import { CreateFormInput } from "src/domain/core/workflow/components/create/LaunchWorkflowForm";

const Row = styled("div")<{ marginBottom?: string }>(({ marginBottom = "30px" }) => ({
  marginBottom,
  display: "flex",
  justifyContent: "space-between",
}));

interface CredentialsInputProps {
  register: UseFormRegister<CreateFormInput>;
  formState: FormState<CreateFormInput>;
  requirePassword: boolean;
}

export const CredentialsInput: React.FC<CredentialsInputProps> = ({ register, formState, requirePassword }) => {
  const [display, setDisplay] = React.useState({
    password: false,
    passwordConfirm: false,
  });

  const handleClickShowPassword = () => {
    setDisplay({
      ...display,
      password: !display.password,
      passwordConfirm: !display.passwordConfirm,
    });
  };

  return (
    <>
      <Row marginBottom="10px">
        <TextField
          fullWidth
          variant="outlined"
          id="username"
          inputProps={{
            "data-testid": "username",
          }}
          label="Username *"
          disabled={true}
          helperText={
            formState.errors?.workflow_owner_username
              ? formState.errors.workflow_owner_username?.message
              : `Workflow username can not be modified here. Please contact an administrator for assistance.`
          }
          {...register("workflow_owner_username")}
          error={formState.errors?.workflow_owner_username && true}
        />
      </Row>
      {requirePassword && (
        <>
          <Row marginBottom="5px">
            <TextField
              label="Password *"
              type={display.password ? "text" : "password"}
              sx={{
                width: "49%",
              }}
              helperText={
                formState.errors?.workflow_owner_password?.message || "Enter password must be a minimum of 6 characters"
              }
              inputProps={{
                "data-testid": "password",
              }}
              {...register("workflow_owner_password")}
              error={formState.errors?.workflow_owner_password && true}
            />

            <TextField
              label="Confirm Password *"
              type={display.passwordConfirm ? "text" : "password"}
              sx={{
                width: "49%",
              }}
              helperText={formState.errors?.workflow_owner_password_confirm?.message || "Type in password again"}
              inputProps={{
                "data-testid": "password-confirm",
              }}
              {...register("workflow_owner_password_confirm", { required: true })}
              error={formState.errors?.workflow_owner_password_confirm && true}
            />
          </Row>
          <Row marginBottom="5px">
            <Button
              onClick={handleClickShowPassword}
              startIcon={display.password ? <VisibilityOff /> : <Visibility />}
              aria-label="toggle password visibility"
            />
          </Row>
        </>
      )}
    </>
  );
};
